import { getToken } from '@/utils/auth'

const DIAGNOSIS_URL = '/new-agent/alarm-analysis/diagnose'

export class AlarmDiagnosisRequestError extends Error {
  constructor(message, status, details) {
    super(message)
    this.name = 'AlarmDiagnosisRequestError'
    this.status = status
    this.details = details
  }
}

function getErrorMessage(status, detail) {
  if (status === 422) return '请求数据格式错误，请检查电站分析上下文'
  if (status === 401) return '登录状态已失效，请重新登录'
  if (status === 403) return '当前账号没有告警智能分析权限'
  return detail?.detail || detail?.message || `智能分析请求失败（HTTP ${status}）`
}

/**
 * 发起告警诊断并逐条消费 SSE 事件。
 * @param {Object} context AlarmAnalysisContext
 * @param {(event: Object) => void} onEvent
 * @param {AbortSignal} [signal]
 */
export async function consumeAlarmDiagnosis(context, onEvent, signal) {
  const token = getToken()
  const language = window.$str?.getLanguage?.() || 'zh-CN'
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'text/event-stream',
    Language: language,
    'System-Sign': 'gemini3'
  }
  if (token) headers.Authorization = `Bearer ${token}`

  const response = await fetch(DIAGNOSIS_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ context, locale: 'zh-CN', stream: true }),
    signal
  })

  if (!response.ok) {
    const detail = await response.json().catch(() => null)
    throw new AlarmDiagnosisRequestError(getErrorMessage(response.status, detail), response.status, detail)
  }
  if (!response.body) {
    throw new AlarmDiagnosisRequestError('浏览器未返回可读的分析数据流', response.status)
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { value, done } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })
    const lines = buffer.split(/\r?\n/)
    buffer = lines.pop() || ''

    for (const line of lines) {
      emitSseLine(line, onEvent)
    }
  }

  buffer += decoder.decode()
  if (buffer) emitSseLine(buffer, onEvent)
}

function emitSseLine(line, onEvent) {
  if (!line.startsWith('data:')) return
  const payload = line.slice(5).trimStart()
  if (!payload) return

  try {
    onEvent(JSON.parse(payload))
  } catch (error) {
    console.warn('忽略无法解析的告警诊断 SSE 数据', error)
  }
}
